import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClientErrorsState {
    addAccountsAccountError: boolean;
    addAccountsAnswerError: boolean;
    smsError: boolean;
    registrationEmailError: boolean;
    registrationPhoneError: boolean;
    registrationAccountError: boolean;
    registrationAnswerError: boolean;
}

const initialState: ClientErrorsState = {
    addAccountsAccountError: false,
    addAccountsAnswerError: false,
    smsError: false,
    registrationEmailError: false,
    registrationPhoneError: false,
    registrationAccountError: false,
    registrationAnswerError: false,
};

export const clientErrorsSlice = createSlice({
    name: '@@vp/clientErrors',
    initialState,
    reducers: {
        setAddAccountsAccountError(state, action: PayloadAction<boolean>): void {
            state.addAccountsAccountError = action.payload;
        },
        setAddAccountsAnswerError(state, action: PayloadAction<boolean>): void {
            state.addAccountsAnswerError = action.payload;
        },
        setSmsError(state, action: PayloadAction<boolean>): void {
            state.smsError = action.payload;
        },
        setRegistrationEmailError(state, action: PayloadAction<boolean>): void {
            state.registrationEmailError = action.payload;
        },
        setRegistrationPhoneError(state, action: PayloadAction<boolean>): void {
            state.registrationPhoneError = action.payload;
        },
        setRegistrationAccountError(state, action: PayloadAction<boolean>): void {
            state.registrationAccountError = action.payload;
        },
        setRegistrationAnswerError(state, action: PayloadAction<boolean>): void {
            state.registrationAnswerError = action.payload;
        },
    }
});

export const {
    setAddAccountsAccountError,
    setAddAccountsAnswerError,
    setSmsError,
    setRegistrationEmailError,
    setRegistrationPhoneError,
    setRegistrationAccountError,
    setRegistrationAnswerError
} = clientErrorsSlice.actions;
